import { render, staticRenderFns } from "./actionButtonTemplate.vue?vue&type=template&id=558c5dcc"
import script from "./actionButtonTemplate.vue?vue&type=script&lang=js"
export * from "./actionButtonTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports